// Gestion du thème crème/sombre (refonte design 2026-05-29 — flip cream par défaut 2026-05-30).
// Toutes les pages sont tokenisées : le défaut est maintenant CRÈME. La bascule sombre
// reste disponible (localStorage persistant).
const CLE = 'escamel_theme';
const DEFAUT_THEME = 'cream';

export function getTheme() {
  try {
    const t = localStorage.getItem(CLE);
    return t === 'cream' || t === 'dark' ? t : DEFAUT_THEME;
  } catch {
    return DEFAUT_THEME;
  }
}

export function applyTheme(theme) {
  const t = theme === 'cream' ? 'cream' : 'dark';
  document.documentElement.setAttribute('data-theme', t);
  return t;
}

export function setTheme(theme) {
  const t = applyTheme(theme);
  try { localStorage.setItem(CLE, t); } catch {}
  return t;
}

export function toggleTheme() {
  return setTheme(getTheme() === 'cream' ? 'dark' : 'cream');
}
